import { Component, computed, inject, ChangeDetectionStrategy } from "@angular/core";
import { UtilityService } from "@eforall/common";
import { VolunteerStatusId } from "@interfaces";
import { AppService, DomainDataService } from "../../../../../../services";
import { VolunteerDialogDataService } from "../../volunteer-dialog-data.service";

@Component({
	selector: 'list-volunteer-status-logs-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './list-volunteer-status-logs.part.html'
})

export class ListVolunteerStatusLogsPart {

	private dialogDataService = inject(VolunteerDialogDataService);
	private utils = inject(UtilityService);
	private domain = inject(DomainDataService);
	private readonly app = inject(AppService);


	public readonly volunteerStatusLogs = computed(() => {
		return this.dialogDataService.volunteerDetails()?.volunteerStatusLogs.map((log) => ({
			...log,
			updatedUTC: this.utils.date.formatUTC(log.updatedUTC, 'MM/DD/YYYY', 'No Time', 'en-US'),
			icon: this.getStatusIcon(log.toVolunteerStatusId),
			status: this.domain.data().volunteerStatusesMap[log.toVolunteerStatusId]?.name,
			displayName: log.updatedByStaffId ? this.app.getStaffNameById(log.updatedByStaffId) : log.updatedByPersonName
		}));
	});

	public getStatusIcon(status: VolunteerStatusId) {
		switch (status) {
			case VolunteerStatusId.Pending:
				return 'fa-fw fa-hourglass-half fa-solid text-secondary'; // Pending
			case VolunteerStatusId.Rejected:
				return 'fa-fw fa-times-circle fa-solid text-danger'; // Rejected
			case VolunteerStatusId.ApprovedWithCaution:
				return 'fa-fw fa-exclamation-triangle fa-solid text-warning'; // Approved with caution
			case VolunteerStatusId.Approved:
				return 'fa-fw fa-check-circle fa-solid text-success'; // Approved
			case VolunteerStatusId.RemovedDueToInactivity:
				return 'fa-fw fa-user-slash fa-solid text-muted'; // Removed due to inactivity
			case VolunteerStatusId.RemovedDueToCause:
				return 'fa-fw fa-user-times fa-solid text-danger'; // Removed due to cause
			case VolunteerStatusId.RemovedByRequest:
				return 'fa-fw fa-user-minus fa-solid text-info'; // Removed by request
			default:
				return 'fa-fw fa-question-circle fa-solid text-secondary'; // Unknown
		}
	}

}